import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import Button from '../../components/common/Button';
import FormField from '../shared/FormField';
import { formsAndPrecedentsApi } from '../../api/facades';

const inputClass = 'w-full rounded-lg border border-gray-300 bg-white dark:bg-slate-800 dark:border-gray-600 py-2 px-3 text-sm text-slate-700 dark:text-slate-200 focus:border-primary-300 focus:outline-none';

const FormCreatePage: React.FC = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const [name, setName] = useState('');
  const [document_name, setDocumentName] = useState('');
  const [keywords, setKeywords] = useState('');
  const [description, setDescription] = useState('');

  const create = useMutation({
    mutationFn: () => formsAndPrecedentsApi.create({ name: name || undefined, document_name: document_name || undefined, keywords: keywords || undefined, description: description || undefined }),
    onSuccess: (data: any) => {
      queryClient.invalidateQueries({ queryKey: ['forms-and-precedents'] });
      const id = data?.data?.id ?? (data?.data && (data.data as any).id);
      if (id) navigate(`/dashboard/forms-and-precedents/${id}`);
      else navigate('/dashboard/forms-and-precedents');
      toast.success('Form or precedent created.');
    },
    onError: (e: any) => toast.error(e?.message || 'Create failed.'),
  });

  const onSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    create.mutate();
  };

  return (
    <div className="bg-white dark:bg-slate-800/50 rounded-2xl p-6 border border-gray-100 dark:border-gray-700">
      <h1 className="text-xl font-bold text-slate-700 dark:text-slate-200 mb-4">New Form or Precedent</h1>
      <form onSubmit={onSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="md:col-span-2">
          <FormField label="Name">
            <input className={inputClass} value={name} onChange={(e) => setName(e.target.value)} placeholder="Optional" />
          </FormField>
        </div>
        <FormField label="Document name">
          <input className={inputClass} value={document_name} onChange={(e) => setDocumentName(e.target.value)} placeholder="Optional" />
        </FormField>
        <FormField label="Keywords">
          <input className={inputClass} value={keywords} onChange={(e) => setKeywords(e.target.value)} placeholder="Optional" />
        </FormField>
        <div className="md:col-span-2">
          <FormField label="Description">
            <textarea className={inputClass} rows={3} value={description} onChange={(e) => setDescription(e.target.value)} placeholder="Optional" />
          </FormField>
        </div>
        <div className="md:col-span-2 flex gap-2 mt-2">
          <Button variant="secondary" type="button" onClick={() => navigate(-1)}>Cancel</Button>
          <Button variant="primary" type="submit" disabled={create.isPending}>{create.isPending ? 'Creating…' : 'Create'}</Button>
        </div>
      </form>
    </div>
  );
};

export default FormCreatePage;
